<template>
    <div class="snackbar-container">
        <div class="snackbar snackbar-opened">
            <span class="snackbar-content"><i class="dripicons-checkmark"></i> {{message}}</span>
        </div>
    </div>
</template>

<script>
  export default {
    props: {
      message: String
    },
    data() {
      return {}
    }
  }
</script>

<style lang="scss">
    .snackbar-container {
        position: fixed;
        bottom: 0;
        left: 0;
        z-index: 99999;
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;

        .snackbar {
            display: inline-block;
            min-width: 100%;
            max-height: 0;
            opacity: 0;
            transition: transform 0.25s cubic-bezier(0, 0, 0.2, 1), opacity 0s 0.25s, max-height 0.25s;
            transform: translateY(100%);

            .snackbar-content {
                display: block;
                padding: .8rem 1.5rem;
                margin-top: 3px;
                font-size: .9rem;
                color: #fff;
                background-color: #323232;
                border-radius: 2px;
            }
            .snackbar-opened {
                max-height: 100px;
                opacity: 1;
                transition: transform .25s cubic-bezier(0, 0, .2, 1), opacity 0s 0s, max-height .25s;
                transform: translateY(0);
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/Snackbar/Snackbar.vue